import PropTypes from "prop-types";

export default function Icon({ name, className, fill, style }) {
  const cls = `material-symbols-rounded${fill ? " fill" : ""}${className ? ` ${className}` : ""}`;
  return (
    <span className={cls} style={style} aria-hidden="true">
      {name}
    </span>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  fill: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

Icon.defaultProps = {
  className: "",
  fill: false,
  style: undefined,
};
